import { MockService } from '../../../core/services/mock.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { Observable, map, delay, catchError, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Response, ItemShareLockInquiryCondition } from '../models/stock-summary-master.model';

@Injectable({
  providedIn: 'root',
})
export class ItemShareStockService {
  // 測試範例為了模擬資料查詢時間，實際開發不會用到
  delay: number = 500;

  constructor(
    private readonly mockService: MockService,
    private readonly httpClient: HttpClient
  ) {}

  getItemShareStock(condition: ItemShareLockInquiryCondition): Observable<Response> {
    let endpoint = `${environment.apiEndpoint}/item-share-stock`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/item-lock-share-lock-inquiry.json'
    );

    if (environment.apiMock) {
          return this.httpClient.get<Response>(endpoint).pipe(
            map((data) => data),
            delay(this.delay)
          );
    }
    return this.httpClient.post<Response>(endpoint, condition);
  }
}
